import React, { useEffect } from 'react';
import classNames from 'classnames';
import HtmlToReactParser from 'html-to-react';
import Icon from '../../assets/icons/Icon';
import { useDict } from '../../contexts/LanguageContext';

const htmlToReactParser = new HtmlToReactParser.Parser();

const CustomCheckBox = (props) => {
    const {
        input,
        label,
        defaultChecked,
        setIsChecked,
        disabled,
        className,
        color,
        meta: { touched, error },
        submitted,
        'data-cy': dataCy,
        pdfLinks,
        openPDFPreview,
    } = props;

    const dict = useDict();

    useEffect(() => {
        if (defaultChecked) {
            input.onChange(defaultChecked);
        }
    }, []);

    useEffect(() => {
        setIsChecked(input.checked);
    }, [input.checked]);

    const CheckboxClass = classNames({
        'checkbox-btn': true,
        disabled,
    });

    return (
        <div className="form__form-group-input-wrap">
            <label className={`${CheckboxClass} ${className ? ` checkbox-btn--${className}` : ''}`}>
                <input
                    className="checkbox-btn__checkbox"
                    type="checkbox"
                    disabled={disabled || submitted}
                    data-cy={dataCy}
                    {...input}
                />
                <span
                    className="checkbox-btn__checkbox-custom"
                    style={
                        color ? { background: color, borderColor: color } : {}
                    }
                >
                    <Icon icon="Check" />
                </span>
                {className === 'button' && (
                    <span className="checkbox-btn__label-svg">
                        <Icon
                            icon="Check"
                            className="checkbox-btn__label-check"
                        />
                        <Icon
                            icon="Close"
                            className="checkbox-btn__label-uncheck"
                        />
                    </span>
                )}
                <span className="checkbox-btn__label">
                    {htmlToReactParser.parse(label)}
                    {pdfLinks.map((pdf, index) => (
                        <span key={index}>
                            <a
                                className="text-blue cursor-pointer"
                                onClick={() => openPDFPreview(pdf.link)}
                            >
                                {' '}{pdf.name}{' '}
                            </a>
                            {index !== pdfLinks.length - 1 && (
                                <>
                                    <span> {dict.and} </span>
                                </>
                            )}
                        </span>
                    ))}
                </span>
            </label>

            {touched && error && (
                <span
                    className="form__form-group-error text-justify"
                    data-cy={`${dataCy}--error`}
                >
                    {error}
                </span>
            )}
        </div>
    );
};

CustomCheckBox.defaultProps = {
    label: '',
    defaultChecked: false,
    disabled: false,
    setIsChecked: () => { },
    submitted: false,
    className: '',
    color: '',
    meta: {
        touched: false,
        error: '',
    },
    'data-cy': undefined,
    pdfLinks: [],
    openPDFPreview: () => { },
};

export default CustomCheckBox;
